Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);

var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=

{

getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"area");
var calculatedValues=this.getCalculatedValues(props);var
scale=calculatedValues.scale,style=calculatedValues.style,data=calculatedValues.data,domain=calculatedValues.domain;var _props=


props,standalone=_props.standalone,interpolation=_props.interpolation,events=_props.events,sharedEvents=_props.sharedEvents,width=_props.width,height=_props.height,groupComponent=_props.groupComponent,theme=_props.theme;

var initialChildProps={
parent:{style:style.parent,width:width,height:height,scale:scale,data:data,domain:domain,standalone:standalone,theme:theme},
all:{
data:{scale:scale,data:data,interpolation:interpolation,groupComponent:groupComponent,style:style.data}}};


return data.reduce(function(childProps,datum,index){
var text=_this.getLabelText(props,datum,index);
if(text!==undefined&&text!==null||events||sharedEvents){
var eventKey=datum.eventKey||index;
childProps[eventKey]={labels:_this.getLabelProps(text,index,calculatedValues)};
}
return childProps;
},initialChildProps);
},

getCalculatedValues:function getCalculatedValues(props){var
theme=props.theme;
var defaultStyles=theme&&theme.area&&theme.area.style?theme.area.style:{};
var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:_victoryCore.Domain.getDomainWithZero(props,"x"),
y:_victoryCore.Domain.getDomainWithZero(props,"y")};

var scale={
x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};


var data=this.getDataWithBaseline(props,scale);
return{style:style,data:data,scale:scale,domain:domain};
},

getLabelProps:function getLabelProps(text,index,calculatedProps){var
scale=calculatedProps.scale,data=calculatedProps.data,style=calculatedProps.style;
var datum=data[index];var _getLabelPosition=
this.getLabelPosition(datum,scale),x=_getLabelPosition.x,y=_getLabelPosition.y;
var labelStyle=this.getLabelStyle(style)||{};
var sign=(datum._y1||datum._y)<0?-1:1;
return{
style:labelStyle,
x:x,
y:y-sign*(labelStyle.padding||0),
text:text,
index:index,
scale:scale,
datum:datum,
data:data,
textAnchor:labelStyle.textAnchor,
verticalAnchor:labelStyle.verticalAnchor||"end",
angle:labelStyle.angle};

},

getLabelText:function getLabelText(props,datum,index){
return datum.label||(Array.isArray(props.labels)?
props.labels[index]:props.labels);
},

getLabelPosition:function getLabelPosition(datum,scale){
return{
x:scale.x(datum._x1!==undefined?datum._x1:datum._x),
y:scale.y(datum._y1!==undefined?datum._y1:datum._y)};

},

getLabelStyle:function getLabelStyle(style){
var dataStyle=style.data||{};
var labelStyle=style.labels||{};

var opacity=dataStyle.opacity;


var fill=dataStyle.stroke;
var padding=labelStyle.padding||0;
return(0,_defaults3.default)({},labelStyle,{opacity:opacity,fill:fill,padding:padding});
},


getDataWithBaseline:function getDataWithBaseline(props,scale){
var data=_victoryCore.Data.getData(props);

if(data.length<2){
_victoryCore.Log.warn("Area requires at least two data points.");
data=[];
}
var defaultMin=_victoryCore.Scale.getType(scale.y)==="log"?1/Number.MAX_SAFE_INTEGER:0;
var domainY=scale.y.domain();
var minY=Math.min.apply(Math,_toConsumableArray(domainY))>0?Math.min.apply(Math,_toConsumableArray(domainY)):defaultMin;

return data.map(function(datum){
var _y1=datum._y1!==undefined?datum._y1:datum._y;
var _y0=datum._y0!==undefined?datum._y0:minY;
return(0,_assign3.default)({},datum,{_y0:_y0,_y1:_y1});
});
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-area/helper-methods.js
// module id = 1428
// module chunks = 0